import { Component, ElementRef, Input, AfterViewInit, ViewChild } from "@angular/core";
import { AnimationState, ItemData } from "../../animation-carousel-panel.component";

@Component({
  selector: "app-animation-carousel-card",
  templateUrl: "./animation-carousel-card.component.html",
  styleUrls: ['./animation-carousel-card.component.less'],
})
export class AnimationCarouselCardComponent implements AfterViewInit {
  @Input() item: ItemData;

  @ViewChild('itemDesc', { static: false }) itemDesc: ElementRef<HTMLElement>;

  animationStates = AnimationState;

  constructor(private hostRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.setCustomThemeProperties(this.item);
  }

  private setCustomThemeProperties(d: ItemData): void {
    if (d.headerColor && d.headerColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--carousel-card-header-color",
        d.headerColor.value
      );
    }

    if (d.backgroundColor && d.backgroundColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--carousel-card-bg-color",
        d.backgroundColor.value
      );
    }

    if (d.descriptionColor && d.descriptionColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--carousel-card-desc-color",
        d.descriptionColor.value
      );
    }
  }
}
